<style scoped  lang="less"> 
   @import 'detailsHead.less';  

</style>
<template>
  <div v-if="match"> 
    <div class="gameHeadBox" :class="(isHeadDown?'':'')+' '+(!(match.state==4&&scoreData)?'gameHeadBox_score':'')">
      <div class="headBox">
        <div class="collect flex flex-pack-center flex-align-center" >
          <span>{{league.fullName}}</span>
          <a href="javascript:void(0);" :class="isFavLeagueState(league.id)" @click.stop="followLeague($event, league)"></a> 
        </div>
        <div class="gameHead " ref="ref_gameHead"  :class="isHeadDown?'':''" v-if="match!=null">
          <!-- 主队 -->
          <!-- <div class="flex team flex-align-center" @click="toTeamPage(match['homeTeam']['id'])"> -->
          <div class="flex flex-align-center team homeTeam">
            <div class="teamImg">
              <img :src="common.teamImgGet(match['homeTeam']['id'])" @error="common.imgError($event, 'team')"  alt="">
              <i class="pen" v-if="isPen('homeTeam',match)"></i>
            </div>
            <div class="teamName txt-r">{{match['homeTeam']['fullName']}}</div>
          </div>

          <!-- 信息 -->
          <div class="message" :class="`${(match.state*1) > 4 && (match.state*1) != 17 ? 'noColor' : ''}  ${match.state*1 == 17 ? 'noStart': ''}`">
            <div class="time">
              {{getGameTime(match.startTime)}}
            </div>
            <!-- 未开始 -->
            <div class="scoreVs noStart" v-if="[0,17].indexOf(match.state*1)>-1">
              <p :class="`${countdown.p1!=24?'p1':''} ${countdown.text.indexOf('In') != -1 ? 'after' : ''}`" >{{countdown.text}}</p>
            </div>
            <div class="scoreVs" v-if="[5,6,13,14,15].indexOf(match.state*1)>-1"> 
              <p>{{langConfig.details[langConfig.curLang]['COUNT_DOWN'][match.state]}}</p>
            </div>
            <!--  //比赛状态 1上半场 2中场休息 3下半场 4完场 5中断 6取消 8加时 11点球 13延期 14腰斩 15待定 17未开赛  zht：暂时补充18：点球完场，19：加时完场-->
            <!-- 比分数据 -->
            <div class="score" v-if="[1,2,3,4,8,11].indexOf(match.state*1)>-1">
              <!-- 顶部 -->
                <div class="scoreNum " :class="isScoreNum('h')?'scoreNum_end':''">{{match.homeLive['scoreFull']?match.homeLive['scoreFull']:0}}</div>
                <div class="scorebox flex flex-align-center">
                  <div class="sb_time" :class="[1,2,3,8,11].indexOf(match.state*1)>-1 ? 'inProgress' : ''">
                    <template  v-if="[1,3].indexOf(match.state*1)>-1">{{ingData}}</template>
                    <!-- <span>{{langConfig.txtLang[langConfig.curLang]['STATE_ARR'][match.state]}}</span> -->
                    <span>{{ getState(match) }}</span>
                    <!-- <span>{{langConfig.txtLang[langConfig.curLang]['STATE_ARR_MATCHDETAILS'][match.state]}}</span> -->
                  </div>
                  <p class="sb_half" v-if="isScoreHalf()">
                    （HT {{match.homeLive['scoreHalf']?match.homeLive['scoreHalf']:0}}:{{match.awayLive['scoreHalf']?match.awayLive['scoreHalf']:0}}）
                  </p>
                </div>
                <div class="scoreNum " :class="isScoreNum('a')?'scoreNum_end':''">{{match.awayLive['scoreFull']?match.awayLive['scoreFull']:0}}</div>
            </div>
          </div>
          
          <!-- 客队 -->
          <!-- <div class="flex team flex-align-center" @click="toTeamPage(match['awayTeam']['id'])"> -->
          <div class="flex team flex-align-center awayTeam">
            <div class="teamImg">
              <img :src="common.teamImgGet(match['awayTeam']['id'])" @error="common.imgError($event, 'team')"  alt="">
              <i class="pen" v-if="isPen('awayTeam',match)"></i>
            </div>
            <div class="teamName">{{match['awayTeam']['fullName']}}</div>
          </div> 
        </div>
      </div>
      <!-- 底部 -->
      <div class="scoreData" v-if="match.state==4 && (match.homeLive.hasOwnProperty('scorePen') != false ||  match.homeLive.hasOwnProperty('scoreOt') != false)"> 
        <span>
          {{scoreData}}
        </span>
      </div>
    </div>
    <div>
   
    </div>  
    <Login :loginShow="loginShow"/>
  </div>
</template>

<script>
import Login from '@/components/login.vue';

export default {
  name: 'detailsHead',
  components: {
    Login
  },
  data() {
    return {
      countdown:{ 
        text:'',// countdown.text
        timeDiff:0,
        p1:24,
        timeDiffserver:null
      },
      countdownTimer:0,
      scoreData:'',
      ingData:'',
      ingTimer:0,
      ingtime:-1,
      loginShow:false,
      startTime:'',
      // isDownShow:false,
      timeGap:null,
    };
  },
  methods: { 
    // 获取比赛状态
    getState(match){
      // 点球完场
      if(match.state == 4 && (match.homeLive.scorePen > 0 || match.awayLive.scorePen > 0)){
        return this.langConfig.txtLang[this.langConfig.curLang]['STATE_ARR_MATCHDETAILS'][18]
      }
      // 加时完场
      else if(match.state == 4 && (match.homeLive.scoreOt > 0 || match.awayLive.scoreOt > 0)){
        return this.langConfig.txtLang[this.langConfig.curLang]['STATE_ARR_MATCHDETAILS'][19]
      }else{
        return this.langConfig.txtLang[this.langConfig.curLang]['STATE_ARR_MATCHDETAILS'][match.state]
      }
    },
    //判断是否点球制胜
    isPen(team,match){
      if(team == 'homeTeam' && match.state == 4 && match.homeLive.scorePen > match.awayLive.scorePen){
        return true
      }else if(team == 'awayTeam' && match.state == 4 && match.homeLive.scorePen < match.awayLive.scorePen){
        return true
      }
    },
    getGameTime(startTime){
      var _tz = '+08:00'
      var _this=this;
      var setting=_this.common.getCookie('setting');  
      var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tz=setting.tsz
      }

      if(this.langConfig.curLang == 'kr'){
        _dateForm = 'YYYY-MM-dd HH:mm';
      }
      var _time=this.common.dateStr(this.common.getDateByArray(_tz, startTime),_dateForm);
      
      var timeArr = _time.split(' ')
      timeArr[1] = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec"][timeArr[1]-1]
      _time = timeArr.join(' ')
      return _time;

    },
    getNowDate(){
      var _tz = '+08:00'
      var _this=this;
      var setting=_this.common.getCookie('setting');  
      var _dateForm = 'dd';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tz=setting.tsz
      }
      var time = Math.floor(Date.now() / 1000)
      var _time=this.common.dateStr(this.common.getDateByArray(_tz, time),_dateForm);
      
      return _time;
    },
    // 联赛关注是否显示
    isFavLeagueState(leagueId){
      let _leagueId = leagueId, _myLeague = this.myLeague, _className= '';

      if(_myLeague != null && Object.keys(_myLeague).length > 0){
        if(typeof(_myLeague[_leagueId]) != 'undefined'){
          _className = 'on';
        }
      }

      return _className;
    },

    followLeague(event, obj){
      event.preventDefault();

      let eventName = 'LS_PC_Leagues_Follow_Click';
      if(this.common.isMobile != 4){
          eventName = 'LS_Webapp_Leagues_Follow_Click';
      }
        
      this.common.googleEvent(eventName, {
          '联赛': obj['fullName'],
          '点击页面': '比赛内页'
      });

      let that = this;

      let _obj = {id: obj.id,fullName: obj.fullName};
      this.common.followLeague(_obj, function(val){
        let _myLeague = {...that.myLeague};
        _myLeague = val;
        // that.myLeague = _myLeague;
        that.$emit('onLeagueFollowChange', _myLeague);
      });
    },
    
    
    isScoreNum(live){
      const { awayLive, homeLive } = JSON.parse(JSON.stringify(this.match));
      const scoreFull_a = awayLive?.scoreFull || 0;
      const scoreFull_h = homeLive?.scoreFull || 0;
      if (scoreFull_h !== 0 && scoreFull_a !== 0) {
        if (scoreFull_h > scoreFull_a) {
          return live === 'h';
        } else if (scoreFull_h < scoreFull_a) {
          return live === 'a';
        }
      }
      return false;
    },
    //判断是否为半场
    isScoreHalf(){
      let match=JSON.parse(JSON.stringify(this.match));
      return match.homeLive['scoreHalf']!=undefined||match.awayLive['scoreHalf']!=undefined
    },
    //倒计时
    updateCountdown(type){
      let match=JSON.parse(JSON.stringify(this.match));
      //console.log('match',match);
      //console.log('match2',this.match);
      var _this=this;
      let countdown=JSON.parse(JSON.stringify(this.countdown));
      if(type==(-1)){
        // countdown.timeDiff=match.startTime-match.serverTimestamp;
        if(countdown.timeDiffserver==null){
          countdown.timeDiffserver=match.serverTimestamp-Math.floor(Date.now() / 1000)
        }
      }
      countdown.timeDiff=match.startTime-Math.floor(Date.now() / 1000)+(countdown.timeDiffserver?countdown.timeDiffserver:0);
      // console.log('countdown.timeDiffserver',countdown.timeDiffserver,'fuwuqi',match.serverTimestamp,countdown.timeDiff);
      //console.log('countdown111',match.serverTimestamp);
      clearTimeout(this.countdownTimer); // 取消定时器
      if(countdown.timeDiff>0){
        const timeDiff=countdown.timeDiff;
        const startMatchDate = this.getGameTime(match.startTime).split(' ')[0]
        const nowDate = this.getNowDate()
        
        const hours = Math.floor(timeDiff / ( 60 * 60));
        const minutes = Math.floor((timeDiff % ( 60 * 60)) / ( 60));
        const seconds = Math.floor((timeDiff % ( 60)) / 1);
        var timeOut=1000;
        if(startMatchDate - nowDate > 1){
          countdown.text = 'In ' + (startMatchDate - nowDate) + ' days'
        }else{
          countdown.p1=24;
          countdown.text=(hours<10?'0'+''+hours:hours)+':'+(minutes<10?'0'+''+minutes:minutes)+':'+(seconds<10?'0'+''+seconds:seconds);
        }
        // if(hours<24){
        //   countdown.p1=24;
        //   countdown.text=(hours<10?'0'+''+hours:hours)+':'+(minutes<10?'0'+''+minutes:minutes)+':'+(seconds<10?'0'+''+seconds:seconds);
        // }else if(24<=hours&&hours<48){

        //   countdown.p1=48;
        //   countdown.text=this.langConfig.details[this.langConfig.curLang]['COUNT_DOWN']['tomorrow'];//'明天开赛';
        //   // timeOut=24*3600*1000;
        // }else if(48<=hours&&hours<72){
        //   countdown.p1=72;
        //   countdown.text=this.langConfig.details[this.langConfig.curLang]['COUNT_DOWN']['after_tomorrow']//'后天开赛';
        //   // timeOut=24*3600*1000;
        // }else if(72<=hours){

        //   countdown.p1=73;
        //   countdown.text=this.langConfig.details[this.langConfig.curLang]['COUNT_DOWN'].nDays(Math.ceil(hours/24));//Math.ceil(hours/24)+'天后开赛';
        //   // timeOut=24*3600*1000;
        // }
        // countdown.timeDiff--;
        //console.log('countdown.timeDiff',countdown.timeDiff);
        this.countdownTimer=setTimeout(function() {
          _this.updateCountdown();
        }, timeOut);
      }else{
        countdown.text='00:00:00'
      }
      //console.log('countdown',countdown);
      this.countdown=countdown;
    },
    // 获取比赛时间
    gameTime(state,time, realtime, svrtime){
      let _start = state, _titme = time, _realtime = realtime, _svrtime = svrtime;
      if([1,3].indexOf(_start)>-1){//上下半场
        let _start = state, _titme = time, _realtime = realtime, _svrtime = svrtime;
        var bssj = 0;
        if(typeof(_realtime) != 'undefined'){
          _titme = _realtime;
        }
        if(_start==1){
          bssj = parseInt((_svrtime - _titme) / 60);
          if (bssj < 0)
            bssj = 0;
          if (bssj > 45)
            bssj = 45;
        }else{
          bssj = parseInt((_svrtime - _titme) / 60) + 45;
          if (bssj < 46)
            bssj = 46;
          if (bssj > 90)
            bssj = 90;
        }
        return bssj;
      }
      return "";
    },
    // 服务器和客户端时间差  
    timeDiff(svrTimestamp){
      if(this.timeGap!=null){return;}
      let _svr = new Date(this.common.jsonParse(svrTimestamp)*1000), _clt = new Date();
      //console.log('服务器时间', _svr)
      this.timeGap = parseInt((_svr - _clt) / 1000 / 60);
    },
    // 比赛进行时间
    ingTimeFn(){
      var _this=this;
      //时区
      var _tsz = '+08:00' 
      var setting=_this.common.getCookie('setting');   
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tsz=setting.tsz
      }

      let match=JSON.parse(JSON.stringify(this.match));
      let state=match.state*1;//状态
      let svrtime=match.serverTimestamp;//服务器时间
     
      let time=match.startTime;//开始时间
      let realtime=match.startHalfTime;//半场时间
      var ingData='';
      if([1,3].indexOf(state*1)>-1){//上下半场
        // 专题太              开始            半场                      服务器
        // let _start = state, 
        // _titme = time, 
        // _realtime = realtime, 
        // _svrtime = svrtime;
        // let _start = _val['state'],
        let _titme = this.common.getDateByArray(_tsz, match['startTime']);
        let _realtime = this.common.getDateByArray(_tsz, match.startHalfTime);
        let _injuryTime = match['injuryTime'];
        //   _svrtime = this.common.getDateByArray(_tsz, svrtime), 
        let _nowtitme = this.common.getDateByArray(_tsz, Date.parse(new Date())/1000);

        var bssj = 1;

        if(typeof(_realtime) != 'undefined' && typeof(match.startHalfTime) != 'undefined'){
          _titme = _realtime;
        }

        if(state==1){
          bssj = parseInt((_nowtitme - _titme) / 60) + (this.timeGap?this.timeGap:0);
          if (bssj < 1){
            bssj = 1;
          }
          if (bssj > 45){
            bssj = 45;
          }
        }else{
          bssj = parseInt((_nowtitme - _titme) / 60) + 45 + (this.timeGap?this.timeGap:0);
          if (bssj < 46){
            bssj = 46;
          }
          if (bssj > 90){
            bssj = 90;
          }
        }
        
        if(typeof(_injuryTime) != 'undefined' && bssj == 90){
          ingData = "90+'";
        }else{
          ingData = bssj+''+"'";
        }
          
        this.ingtime=bssj*1;
        // ingData=bssj+ (match.injuryTime?'+':'')+"'";
      }else{
        ingData='';
      }
      //console.log('ingData',ingData);
      var ingTime=this.$route.query.ingTime;
      if(ingTime){
        //console.log('ingData',ingData);
      }
      this.ingData=ingData;
      clearTimeout(this.ingTimer);
      if([1,3].indexOf(state*1)>-1){
        this.ingTimer=setTimeout(function() {
          // _this.ingTimeAdd();
          _this.ingTimeFn();
        }, 6*1000);
      }
    },
    ingTimeAdd(){
      var _this=this;
      let match=JSON.parse(JSON.stringify(this.match));
      let ingtime=JSON.parse(JSON.stringify(this.ingtime));
      let state=match.state*1;
      clearTimeout(this.ingTimer);
      ingtime=ingtime*1+1;
      if (state == 1) {
        ingtime = ingtime > 45 ? 45 : ingtime;
      }
      if (state == 3) {
        ingtime = ingtime > 90 ? 90 : (ingtime < 45 ? 45 : ingtime);
      }
      this.ingtime=ingtime;
      this.ingData=ingtime*1+ (match.injuryTime?'+':'')+"'";
      if([1,3].indexOf(state*1)>-1){
        this.ingTimer=setTimeout(function() {
          _this.ingTimeAdd();
        }, 60*1000);
      }
    },
    
    // 跳转球队主页
    toTeamPage(teamId) {
      this.$router.push(`${this.common.secondDir}/leagues/team/${teamId}/1`);
    },
    init(){
      this.updateCountdown(-1);//倒计时
      //this.checkgameHeadView();
      let match=JSON.parse(JSON.stringify(this.match));
      this.timeDiff(match.serverTimestamp);
      //拼接scoreData
      function isObject(myObject){
        if (typeof myObject !== "undefined" && myObject !== null) {
          return true;
        }else{
          return false;
        }
      }
      var scoreData=``;
      if(isObject(match.homeLive['scoreFull'] || 0) || isObject(match.awayLive['scoreFull'] || 0)){
        scoreData+= this.langConfig.details[this.langConfig.curLang]['REMARKS']['90min'].replace('?1', '[' + (match.homeLive['scoreFull'] || 0)).replace('?2', (match.awayLive['scoreFull'] || 0) + ']');
      }
      if(isObject(match.homeLive['scoreRound1'])&&isObject(match.awayLive['scoreRound1'])){
        if(scoreData != ''){
          scoreData += ', ';
        }
        scoreData+= this.langConfig.details[this.langConfig.curLang]['REMARKS']['first'].replace('?1', '[' + match.homeLive['scoreRound1']).replace('?2', match.awayLive['scoreRound1'] + ']');
      }
      if(isObject(match.homeLive['scoreRound2'])&&isObject(match.awayLive['scoreRound2'])){
        if(scoreData != ''){
          scoreData += ', ';
        }
        scoreData+= this.langConfig.details[this.langConfig.curLang]['REMARKS']['second'].replace('?1', '[' + match.homeLive['scoreRound2']).replace('?2', match.awayLive['scoreRound2'] + ']');
      }
      if(isObject(match.homeLive['scoreOt'])&&isObject(match.awayLive['scoreOt'])){
        if(scoreData != ''){
          scoreData += ', ';
        }
        scoreData+= this.langConfig.details[this.langConfig.curLang]['REMARKS']['120min'].replace('?1', '[' + match.homeLive['scoreOt']).replace('?2', match.awayLive['scoreOt'] + ']');
      } 
      if(isObject(match.homeLive['scorePen'])&&isObject(match.awayLive['scorePen'])){
        if(scoreData != ''){
          scoreData += ', ';
        }
        scoreData+= this.langConfig.details[this.langConfig.curLang]['REMARKS']['penalyty'].replace('?1', '[' + match.homeLive['scorePen']).replace('?2', match.awayLive['scorePen'] + ']');
      }
      //console.log('scoreData',scoreData);
      this.scoreData=scoreData.split(',').filter(item => item != " ").join();
      //状态
      this.ingTimeFn();
      
    },
  },
  created() {
    if(typeof(window) == 'undefined' && this.match.state==4){
      this.init();
    }
  },
  watch: {
    match(val){
      this.init(); 
    },
  },
  mounted(){
  },
  beforeDestroy() {
  },
  props: {
    match: {
      type: Object,
      default:null
    }, 
    isHeadDown:{
      type: Boolean,
      default:false
    },
    league: {
      type: Object,
      default:null
    }, 
    myLeague: {
      type: Object,
      default: () => {}
    },
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsHead.vue